import PropTypes from "prop-types";

function P2BasicTabs(props) {
  return (
    <div
      className="polymer-basic-tabs-container"
      style={{ ...props.tabsContainerStyle }}
    >
      {props.titles.map((item, _index) => (
        <div
          style={{ ...props.tabStyle }}
          key={_index}
          className={`polymer-basic-tabs-item polymer-basic-tabs-item__${
            !props.disabledTitles.includes(item) ? props.variant : "disabled"
          } 
          ${
            props.selectedTabIndex === _index &&
            !props.disabledTitles.includes(item)
              ? `polymer-basic-tabs-item__${props.variant}__selected`
              : ""
          } 
          ${
            props.isCompact &&
            `polymer-basic-tabs-item__compact${props.icon ? "__icon" : ""}`
          }
          `}
          onClick={() => {
            if (props.onChange) {
              props?.onChange(_index);
            }
          }}
        >
          {props.icon && <div>{props.icon}</div>}
          <p style={{ ...props.titleStyle }}>{item}</p>
        </div>
      ))}
    </div>
  );
}

export default P2BasicTabs;

P2BasicTabs.propTypes = {
  variant: "dark" | "light",
  isCompact: PropTypes.any,
  tabsContainerStyle: PropTypes.any,
  tabStyle: PropTypes.any,
  icon: PropTypes.element,
  titles: PropTypes.arrayOf(PropTypes.string),
  disabledTitles: PropTypes.arrayOf(PropTypes.string),
  selectedTabIndex: PropTypes.number,
  titleStyle: PropTypes.any,
  onChange: PropTypes.func,
};

P2BasicTabs.defaultProps = {
  variant: "dark",
  titles: [],
  selectedTabIndex: 0,
  isCompact: false,
  disabledTitles: [],
};
